import React from "react";

/**
 * Nador Sage International — replicates the Great Asia Pacific globe mark
 * (outer circle + equator + meridian arcs), monochrome navy only.
 * Pure stroke construction, no fills, no accent color.
 */
export const LogoMark = ({ size = 38, stroke = "#0b1a2e", className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
    >
        {/* Outer circle */}
        <circle cx="24" cy="24" r="20.5" stroke={stroke} strokeWidth="1.4" />
        {/* Equator */}
        <line x1="3.5" y1="24" x2="44.5" y2="24" stroke={stroke} strokeWidth="1.1" />
        {/* Prime meridian */}
        <line x1="24" y1="3.5" x2="24" y2="44.5" stroke={stroke} strokeWidth="1.1" />
        {/* Meridian arcs (left + right) */}
        <ellipse cx="24" cy="24" rx="10" ry="20.5" stroke={stroke} strokeWidth="1.1" />
        <ellipse cx="24" cy="24" rx="20.5" ry="10" stroke={stroke} strokeWidth="1.1" opacity="0.45" />
    </svg>
);

export const Wordmark = ({ className = "", inverse = false }) => {
    const ink = inverse ? "#f4f4f3" : "#0b1a2e";
    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <LogoMark size={38} stroke={ink} />
            <span
                className="font-display text-[18px] font-semibold tracking-tight"
                style={{ color: ink }}
            >
                Nador Sage International
            </span>
        </div>
    );
};

export default Wordmark;
